import { Box, IconButton, Typography } from '@mui/material';
import DataTable from 'components/Common/DataTable';
import { ColumnDef } from '@tanstack/react-table';
import { MdOutlineEdit } from 'react-icons/md';
import { RiDeleteBin6Line } from 'react-icons/ri';
import Button from 'components/Common/Button';
import { Link, Outlet, useNavigate } from 'react-router-dom';
import { GoPlus } from 'react-icons/go';
import { useDeleteTeamMember, useGetTeamMembers } from 'apis/business/setting/team/hook';
import { TeamMember } from 'apis/business/setting/team/types';
import Pagination, { usePagination } from 'components/Common/Pagination';

export default function TeamMembers() {
  const navigate = useNavigate();

  const { currentPage, perPage, setPage, setPerPage } = usePagination();
  const { data: teamMembers, isLoading: isTeamMembersLoading } = useGetTeamMembers({
    page: currentPage,
    per_page: perPage
  });

  const { mutate: deleteTeamMember } = useDeleteTeamMember();

  return (
    <>
      <Box display='flex' justifyContent='space-between' alignItems='center' mb={2}>
        <Typography variant='h6' fontWeight={500}>
          Team
        </Typography>
        <Button onClick={() => navigate('add')} variant='contained' color='primary' startIcon={<GoPlus />}>
          Add Member
        </Button>
      </Box>
      <DataTable
        data={teamMembers?.data}
        columns={columns(deleteTeamMember)}
        isHeaderSticky={true}
        isLoading={isTeamMembersLoading}
      />
      <Pagination
        totalPages={teamMembers?.meta?.total_pages}
        totalCount={teamMembers?.meta?.total_count ?? 0}
        currentPage={currentPage}
        perPage={perPage}
        onChange={setPage}
        onPerPageChange={setPerPage}
      />
      <Outlet />
    </>
  );
}

type DeleteTeamMemberFn = (id: string) => void;

const columns = (deleteTeamMember: DeleteTeamMemberFn): ColumnDef<TeamMember>[] => [
  {
    header: 'Name',
    accessorKey: 'name'
  },
  {
    header: 'Email',
    accessorKey: 'email'
  },
  {
    header: 'Phone',
    accessorKey: 'phone_number'
  },
  {
    header: 'Role',
    accessorKey: 'role',
    cell: (info: any) => info.getValue().replace(/_/g, ' ')
  },
  {
    header: 'Action',
    cell: (info) => (
      <Box display='flex' gap={1}>
        <Link to={String(info.row.original.id)}>
          <IconButton>
            <MdOutlineEdit />
          </IconButton>
        </Link>
        <IconButton onClick={() => deleteTeamMember(String(info.row.original.id))} color='error'>
          <RiDeleteBin6Line style={{ color: 'red' }} />
        </IconButton>
      </Box>
    )
  }
];
